import React, { useState } from 'react';
import { Translation } from 'react-i18next';
import { Row, Col } from 'antd';

import useWindowDimensions from '../../../../../lib/WindowDimensions';
import LearningModuleSerieList from '../containers/LearningModuleSerieListContainer';
import LearningModuleFilters from '../containers/LearningModuleFiltersContainer';
import useDebounce from '../../../elements/components/useDebounce';
import { Typography, Empty } from 'antd';

import LoadingSmall from '../../../elements/components/LoadingSmall';

const { Title, Text } = Typography;

function LearningScreen({ moduleSerieTypes, total, isLoading, ...props }) {
  const { width } = useWindowDimensions();
  const isSmall = width <= 576;
  const isMedium = (width) => 768 && width <= 992;

  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 1000);
  const [selectedTags, setSelectedTags] = useState([]);
  const [state, setState] = useState([]);

  const onSearch = (e) => {
    setQuery(e.target.value);
  };

  return (
    <Translation>
      {(t) => (
        <Row
          gutter={16}
          style={{
            margin: isSmall ? '0' : isMedium ? '20px 10px 0' : '40px 20px 0',
          }}
        >
          <Col
            lg={{ span: 18, order: 1 }}
            md={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            xs={{ span: 24, order: 2 }}
          >
            {isLoading && <LoadingSmall />}
            {moduleSerieTypes.map((x) => (
              <LearningModuleSerieList
                action={x.action}
                value={x.value}
                debouncedQuery={debouncedQuery}
                selectedTags={selectedTags}
                state={state}
              />
            ))}
            {total === 0 && (
              <div className='learning-empty'>
                <Empty
                  description={
                    <>
                      <Title level={3} className='learning-empty-title'>
                        {t('learning_empty_title')}
                      </Title>
                      <Text>{t('learning_empty_description')}</Text>
                    </>
                  }
                />
              </div>
            )}
          </Col>

          <Col
            lg={{ span: 6, order: 2 }}
            md={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            xs={{ span: 24, order: 1 }}
          >
            <LearningModuleFilters
              onSearch={onSearch}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
              setState={setState}
            />
          </Col>
        </Row>
      )}
    </Translation>
  );
}

export default LearningScreen;
